import styled from "styled-components";

export const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 82vh;
  background-color: white;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 10px 20px 20px;
  margin-left: -24px;
  margin-top: -10px;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const TitleContainer = styled.div`
  gap: 8px;
  margin: 20px 0px 0px 0px;
`;

export const TitleFieldText = styled.p`
  //styleName: Body Text Med;
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

// AccordionRightIconDropDownStyling

export const DropDownBody = styled.div`
  height: 96px;
  padding: 16px 0px 0px 0px;
  gap: 8px;
  opacity: 0px;
  width: 408px;
  border-radius: 0px 0px 8px 8px;
`;

export const DropDownListItem = styled.div`
  width: ${(props) => props.width || "100%"};
  height: 32px;
  margin: 2px 8px 0px 8px;
  display: flex;
  cursor: pointer;
`;

export const DropDownTextStyle = styled.p`
  //styleName: Body Text Reg;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  margin-top: 5.5px;
`;

export const TextDiv = styled.div`
  margin-left: 10px;
`;

export const DropDownIconDiv = styled.div`
  // font-size: 25px;
`;
